// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eVJs","title":"styles_title__15yu8"};